import gql from 'graphql-tag';

/**
 * Keycode Validation Query
 */
export const VALIDATE_KEYCODE = gql`
	query ValidateKeyCode($keyCode: String!, $variantId: Int!) {
		validateKeyCode(keyCode: $keyCode, variantId: $variantId) {
			code
		}
	}
`;
